// @mui
import { Box, Stack } from '@mui/material';
// config
import { ErrorScreen } from 'components/loading-screen';
import { LoadingFullScreen } from 'components/loading-screen/LoadingScreen';
import { useGetNavigationConfig } from 'services/auth/authServices';
import { NAV } from '../../../config-global';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';
// components
import Logo from '../../../components/logo';
import { NavSectionMini } from '../../../components/nav-section';
//
import { getUltimateNavigation } from '../../../utils/helper';
import NavSidebarLogout from './NavSidebarLogout';
import NavToggleButton from './NavToggleButton';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { data: navConfig, isLoading, isError } = useGetNavigationConfig();

  if (isLoading) return <LoadingFullScreen />;
  if (isError) return <ErrorScreen />;

  const ultimateNavigation = getUltimateNavigation(navConfig);
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          height: 1,
          overflow: 'hidden',
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          bgcolor: '#fff',
          borderRight: 'none',
          boxShadow: '2px 0 10px -4px rgba(15, 23, 42, 0.08)',
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <Box sx={{ flexGrow: 1, minHeight: 0, overflowY: 'auto' }}>
          <NavSectionMini data={ultimateNavigation} />
        </Box>

        <NavSidebarLogout isMini />
      </Stack>
    </Box>
  );
}
